import P5 from "p5";
import { CoinFlipper } from "./coin-flipper";

const flipper = new CoinFlipper();
const distribution1 = new Map<number, number>();
const distribution2 = new Map<number, number>();
const distribution3 = new Map<number, number>();
const distribution4 = new Map<number, number>();
const distribution5 = new Map<number, number>();
const distribution6 = new Map<number, number>();

const addToDistribution = (
  distribution: Map<number, number>,
  sequenceLength
) => {
  const flips = flipper.flips(sequenceLength);
  const sum = flips.reduce((acc, cur) => acc + cur, 0);

  const count = distribution.get(sum) ?? 0;
  distribution.set(sum, count + 1);
};

const drawHistogram = (
  p5: P5,
  color: P5.Color,
  frequencies: Map<number, number>,
  x: number,
  y: number,
  text: string
) => {
  p5.push();

  p5.translate(x, y);

  const sortedKeys = Array.from(frequencies.keys()).sort((a, b) => a - b);
  const min = sortedKeys[0];
  const max = sortedKeys[sortedKeys.length - 1];
  const maxCount = Array.from(frequencies.values()).reduce(
    (acc, curr) => (curr > acc ? curr : acc),
    Number.MIN_SAFE_INTEGER
  );

  p5.fill(color);
  p5.text(0, x - 3.5, y + 12);
  p5.text(max, max + x - 12, y + 12);
  p5.text(min, x + min, y + 12);
  p5.textStyle("italic");
  p5.text(text, x + min, y + 30);

  p5.rect(x + min, y, -min + max, 1);

  sortedKeys.forEach((value) => {
    let count = frequencies.get(value) ?? 0;
    count = (count / maxCount) * 100;

    if (value === 0) {
      p5.fill(p5.color("red"));
    } else {
      p5.fill(color);
    }

    if (frequencies.has(value)) {
      p5.rect(value + x, y, 1, count * -1);
    }
  });

  p5.pop();
};

const sketch = (p5: P5) => {
  const backgroundColor = p5.color("#fdfdfd");
  const zeroLine = p5.color("black");

  p5.setup = () => {
    const canvas = p5.createCanvas(740, 550);
    canvas.parent("fig2");
    p5.noStroke();
    p5.background(backgroundColor);

    p5.frameRate(120);
  };

  p5.draw = () => {
    p5.background(backgroundColor);
    addToDistribution(distribution1, 50);
    addToDistribution(distribution2, 100);
    addToDistribution(distribution3, 400);
    addToDistribution(distribution4, 800);
    addToDistribution(distribution5, 1600);
    addToDistribution(distribution6, 3200);

    drawHistogram(
      p5,
      zeroLine,
      distribution1,
      50,
      60,
      "i) Sequence length: 50"
    );
    drawHistogram(
      p5,
      zeroLine,
      distribution2,
      50,
      140,
      "ii) Sequence length: 100"
    );
    drawHistogram(
      p5,
      zeroLine,
      distribution3,
      50,
      220,
      "iii) Sequence length: 400"
    );

    drawHistogram(
      p5,
      zeroLine,
      distribution4,
      250,
      60,
      "iv) Sequence length: 800"
    );
    drawHistogram(
      p5,
      zeroLine,
      distribution5,
      250,
      140,
      "v) Sequence length: 1600"
    );
    drawHistogram(
      p5,
      zeroLine,
      distribution6,
      250,
      220,
      "vi) Sequence length: 3200"
    );

    p5.push();
    p5.textStyle("italic");
    p5.text(
      "Figure 2: Distribution of Different Lengths of the Coin Flip Random Process",
      0,
      p5.height - 20
    );
    p5.pop();
  };
};

new P5(sketch);
